<template>
    <div class="pc-footer-container">
        <div class="footer-main-box">
            <div class="link1-box">
                <div class="link-item">
                    <p class="title">云产品</p>
                    <ul class="links">
                        <li class="item">
                            <a>产品</a>
                        </li>
                        <li class="item">
                            <a>客户案例</a></li>
                        <li class="item">
                            <a>产品发布台</a>
                        </li>
                        <li class="item">
                            <a>网站备案</a>
                        </li>
                        <li class="item">
                            <a>认证信息</a>
                        </li>
                        <li class="item">
                            <a>许可证说明</a>
                        </li>
                        <li class="item">
                            <a>隐私声明</a>
                        </li>
                        <li class="item">
                            <a>关于我们</a>
                        </li>
                    </ul>
                </div>
                <div class="link-item">
                    <p class="title">解决方案</p>
                    <ul class="links">
                        <li class="item">
                            <a>视频</a>
                        </li>
                        <li class="item">
                            <a>游戏</a>
                        </li>
                        <li class="item">
                            <a>金融</a>
                        </li>
                        <li class="item">
                            <a>电商</a>
                        </li>
                        <li class="item">
                            <a>网站</a>
                        </li>
                        <li class="item">
                            <a>大数据</a>
                        </li>
                        <li class="item">
                            <a>人脸核身</a>
                        </li>
                        <li class="item">
                            <a>在线教育</a>
                        </li>
                        <li class="item">
                            <a>Web3.0</a>
                        </li>
                        <li class="item">
                            <a>Web3.0音视频</a>
                        </li>
                    </ul>
                </div>
                <div class="link-item">
                    <p class="title">资源与社区</p>
                    <ul class="links">
                        <li class="item">
                            <a>免费套餐</a>
                        </li>
                        <li class="item">
                            <a>入门中心</a>
                        </li>
                        <li class="item">
                            <a>定价中心</a>
                        </li>
                        <li class="item">
                            <a>资源中心</a>
                        </li>
                        <li class="item">
                            <a>腾讯云大学</a>
                        </li>
                        <li class="item">
                            <a>云+社区</a>
                        </li>
                        <li class="item">
                            <a>人脸核身</a>
                        </li>
                        <li class="item">
                            <a>在线教育</a>
                        </li>
                        <li class="item">
                            <a>Web3.0</a>
                        </li>
                        <li class="item">
                            <a>Web3.0音视频</a>
                        </li>
                    </ul>
                </div>
                <div class="link-item">
                    <p class="title">合作与生态</p>
                    <ul class="links">
                        <li class="item">
                            <a>合作伙伴</a>
                        </li>
                        <li class="item">
                            <a>合作伙伴学院</a>
                        </li>
                        <li class="item">
                            <a>推广奖励</a>
                        </li>
                        <li class="item">
                            <a>资源中心</a>
                        </li>
                        <li class="item">
                            <a>腾讯云大学</a>
                        </li>
                        <li class="item">
                            <a>云+社区</a>
                        </li>
                        <li class="item">
                            <a>人脸核身</a>
                        </li>
                        <li class="item">
                            <a>在线教育</a>
                        </li>
                        <li class="item">
                            <a>Web3.0</a>
                        </li>
                        <li class="item">
                            <a>Web3.0音视频</a>
                        </li>
                    </ul>
                </div>
                <div class="link-item">
                    <p class="title">管理与支持</p>
                    <ul class="links">
                        <li class="item">
                            <a>公告</a>
                        </li>
                        <li class="item">
                            <a>控制台</a>
                        </li>
                        <li class="item">
                            <a>续费管理</a>
                        </li>
                        <li class="item">
                            <a>访问管理</a>
                        </li>
                        <li class="item">
                            <a>安全中心</a>
                        </li>
                        <li class="item">
                            <a>举报平台</a>
                        </li>
                        <li class="item">
                            <a>工单管理</a>
                        </li>
                        <li class="item">
                            <a>联系我们</a>
                        </li>
                    </ul>
                </div>
                <div class="web-links">
                    <p class="title">友情链接</p>
                    <ul class="links">
                        <li class="item mq-flex-between-center">
                            <div class="logo">
                                <img src="https://cdn.mvcsky.com/footer/p2ipo-link-logo2x.png" class="p2ipo" alt="">
                            </div>
                            <div class="info">
                                <p class="name">上市孵化器</p>
                                <a href="http://www.p2ipo.com" target="_blank">www.p2ipo.com</a>
                            </div>
                        </li>
                        <li class="item mq-flex-between-center">
                            <div class="logo">
                                <img src="https://cdn.mvcsky.com/footer/bigbays-link-logo2x.png" class="bigbays" alt="">
                            </div>
                            <div class="info">
                                <p class="name">湾潮</p>
                                <a href="https://www.bigbays.cn" target="_blank">www.bigbays.cn</a>
                            </div>
                        </li>
                        <li class="item mq-flex-between-center">
                            <div class="logo">
                                <img src="https://cdn.mvcsky.com/footer/shyc-link-logo2x.png" class="b2bscm" alt="">
                            </div>
                            <div class="info">
                                <p class="name">山海云仓</p>
                                <a href="http://www.b2bscm.net" target="_blank">www.b2bscm.net</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="link2-box">
                <!-- <ul class="product-list">
                    <li v-for="n in 30" :key="n">热门产品</li>
                </ul> -->
            </div>
            <p class="copyright">
                <span class="txt1">苍穹云系统(深圳)有限公司版权所有 Copyright©CQY All Rights Reserved</span>
                <a class="txt2" href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2022104031号</a>
            </p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'pcFooter',
    data() {
        return {}
    }
}
</script>
<style lang="scss" scoped>
@import './PcFooter.scss';
</style>


// WEBPACK FOOTER //
// src/components/pc/common/footer/PcFooter.vue